import { CommentsQuestionPage } from '../comments/comments-question-page';
import { EffectivenessViewModel } from './effectiveness-viewmodel';
import { GroupResultModel } from './group-result-model';
import { ResultsStatuses } from './results-statuses';
import { SurveyResultModel } from './survey-result-model';

export interface SurveyResultsModel {
  self: SurveyResultModel;
  benchmark: SurveyResultModel;
  others: SurveyResultModel | null;
  commentsQuestionPages: CommentsQuestionPage[];
  effectivenessModel: EffectivenessViewModel;
  campaignEffectivenessModel: EffectivenessViewModel;
  groupResults: GroupResultModel[];
  resultStatus: ResultsStatuses;
  resultsStatus?: ResultsStatuses;
  reportReleaseDate: Date;
}
